import { render, staticRenderFns } from "./investmentServices.vue?vue&type=template&id=3b18e91e&"
import script from "./investmentServices.vue?vue&type=script&lang=js&"
export * from "./investmentServices.vue?vue&type=script&lang=js&"
import style0 from "./investmentServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports